import React, {Fragment} from "react";
import {Button, Form, InputGroup} from "react-bootstrap";
import SVG from "react-inlinesvg";
import smiley from "../../../assets/svg/actions/icn-smiley.svg";

import sendActive from "../../../assets/svg/actions/icn-send-active.svg";
import sendInActive from "../../../assets/svg/actions/icn-send-inactive.svg";
import attachment from "../../../assets/svg/actions/icn-attachment.svg";

// chat input bubbles
import "../../../assets/sass/components/messages/chat/chat-bubbles.scss";
import PickerData from 'emoji-mart/data/google.json'
import {NimblePicker} from "emoji-mart";
import 'emoji-mart/css/emoji-mart.css'

import * as PropTypes from "prop-types";
import Tools from "../../../Tools";
import AttachmentFileModal from "./modals/AttachmentFileModal";
import { ThemeContext } from '../../layouts/ThemeProvider';
import Icon from "../Icon";

class ChatBubbles extends React.Component {

    inputChatBubblesRef = React.createRef();
    fileAttachment = React.createRef();

    state = {
        message: '',
        messageHeight: 48,
        attachment: {},
        showEmojiPicker: false,
        showAttachmentFileModal: false,
    }

    onHideAttachmentFileModal = () => {
        this.setState({
            showAttachmentFileModal: false,
        });
    }

    onSubmit = (event) => {
        event.preventDefault();

        var {onSubmit} = this.props;
        if (onSubmit)
            onSubmit(event, { message: this.state.message, attachment: false });

        this.setState({
            message: "",
        })
    }

    onAttachmentSubmit = (event, message) => {

        event.preventDefault();

        var attachment = this.state.attachment;
        attachment.message = message;

        var {onAttachmentSubmit} = this.props;
        if (onAttachmentSubmit)
            onAttachmentSubmit(event, { message: false, attachment: attachment });

        this.setState({
            showAttachmentFileModal: false,
        })

        this.fileAttachment.current.value = '';
    }

    onInput = (event) => {

        var messageHeight = this.inputChatBubblesRef.current.scrollHeight > 160
            ? this.state.messageHeight
            : this.inputChatBubblesRef.current.scrollHeight;

        this.setState({
            message: event.target.value,
            messageHeight: messageHeight
        }, () => {
            if(!this.state.message) {
                this.setState({
                    messageHeight: 48
                })
            }
        })
    }


    addEmoji = (emoji) => {
        const { message } = this.state;
        const text = `${message}${emoji.native}`;

        this.inputChatBubblesRef.current.focus();

        this.setState({
            message: text,
            showEmojiPicker: false,
        });
    }

    uploadFileAttachment = async () => {
        var file = this.fileAttachment.current.files[0];
        var base64 = await Tools.toBase64(file);
        this.setState({
            attachment: {
                message: '',
                name: file.name,
                size: file.size,
                type: file.type,
                base64: base64,
            }
        },() => {
            this.setState({
                showAttachmentFileModal: true
            });
        })
    }

    toggleEmojiPicker = () => {
        this.setState({
            showEmojiPicker: !this.state.showEmojiPicker,
        });
    }

    emojiPicker = () => {
        var {showEmojiPicker} = this.state;
        const theme = this.context;
        return showEmojiPicker ? (
            <NimblePicker set="google" data={PickerData} onSelect={this.addEmoji} theme={theme === 'dark' ? 'dark' : 'light'} />
        ) : null;
    }

    render() {

        var {placeholder}  = this.props;

        return (
            <Fragment>
                <Form className="chat-bubbles-form" onSubmit={this.onSubmit} ref="chat_bubbles">
                    {this.emojiPicker()}
                    <InputGroup className="chat-bubbles">
                        <InputGroup.Append>
                            <InputGroup.Text>
                                <Button variant="link" onClick={this.toggleEmojiPicker}><SVG src={smiley}/></Button>
                            </InputGroup.Text>
                        </InputGroup.Append>
                        <Form.Control as="textarea" style={{ height: this.state.messageHeight }} autocomplete={false} ref={this.inputChatBubblesRef} name="text" placeholder={placeholder ?? "Type your message here..."} value={this.state.message} onInput={this.onInput}/>
                        <InputGroup.Append>
                            <InputGroup.Text>
                                <Button variant="link" >
                                    <input
                                        type="file"
                                        ref={this.fileAttachment}
                                        accept="*"
                                        onChange={this.uploadFileAttachment}
                                    />
                                    <SVG src={attachment}/>
                                </Button>
                            </InputGroup.Text>
                        </InputGroup.Append>
                        <InputGroup.Append>
                            <InputGroup.Text>
                                <Button variant="link" onClick={this.onSubmit}>
                                    <Icon svg={this.state.message ? sendActive : sendInActive}/>
                                </Button>
                            </InputGroup.Text>
                        </InputGroup.Append>
                    </InputGroup>
                </Form>
                <AttachmentFileModal onHide={this.onHideAttachmentFileModal} show={this.state.showAttachmentFileModal} attachment={this.state.attachment} onAttachmentSubmit={this.onAttachmentSubmit}/>
            </Fragment>
        )
    }

    static contextType = ThemeContext

    static propTypes = {
        placeholder: PropTypes.string,
        onSubmit: PropTypes.func,
    };
};

export default ChatBubbles;
